module.exports = __webpack_public_path__ + "img/humidifier1.77170e87.png";